import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyA1qdRGMpkKvYuBDhdtH9QrLej-xFkuyQI',
  authDomain: 'falcon-marketing-84a0f.firebaseapp.com',
  projectId: 'falcon-marketing-84a0f',
  storageBucket: 'falcon-marketing-84a0f.firebasestorage.app',
  messagingSenderId: '456516958920',
  appId: '1:456516958920:web:44aa1bdc115295a2f343fd',
  measurementId: 'G-LN365GQ0PH',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

if (typeof window !== 'undefined') {
  getAnalytics(app);
}
